
import Vue from 'vue';

import WorkflowGraph from './components/WorkflowGraph';
Vue.component(WorkflowGraph.name, WorkflowGraph);

import UserGuide from './components/UserGuide';
Vue.component(UserGuide.name, UserGuide);

import CustomerScheduleInfo from './components/CustomerScheduleInfo';
Vue.component(CustomerScheduleInfo.name, CustomerScheduleInfo);

import MenuSwitchButton from './components/sidebar/MenuSwitchButton';
Vue.component(MenuSwitchButton.name, MenuSwitchButton);

import EditorSummernote from './components/EditorSummernote';
Vue.component(EditorSummernote.name, EditorSummernote);

import SideBar from './components/sidebar/SideBar';
Vue.component(SideBar.name, SideBar);

import MessageCenter from './components/MessageCenter';
Vue.component(MessageCenter.name, MessageCenter);

import BudoTextarea from './components/BudoTextarea';
Vue.component(BudoTextarea.name, BudoTextarea);

import UserGuideCarousel from './components/UserGuideCarousel';
Vue.component(UserGuideCarousel.name, UserGuideCarousel);



// WEBPACK FOOTER //
// ./src/components-common.js